"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { BoltIcon, BookIcon, ReportIcon } from "@/components/icons";
import { InboxCountBadge } from "@/components/monitoring/InboxCountBadge";
import type { SidebarMode } from "./types";
import { APP_HOME } from "@/lib/appHome";

/** Mode switcher: the panel below changes with the selected pillar. */
export function ModeSwitcher({
  mode,
  pathname,
  inboxCount = null,
  onCloseDrawer,
}: {
  mode: SidebarMode;
  pathname: string;
  /** The whole business's Inbox count, shown on the Monitoring entry in every mode. */
  inboxCount?: number | null;
  onCloseDrawer: () => void;
}) {
  return (
    <div className="grid grid-cols-3 gap-1 pt-1.5">
      {(
        [
          { m: "kb", href: "/knowledge", label: "Knowledge", icon: <BookIcon className="size-4" /> },
          { m: "automation", href: APP_HOME, label: "Automation", icon: <BoltIcon className="size-4" /> },
          { m: "reports", href: "/monitoring", label: "Monitoring", icon: <ReportIcon className="size-4" /> },

        ] as { m: SidebarMode; href: string; label: string; icon: ReactNode }[]
      ).map(({ m, href, label, icon }) => (
        <Link
          key={m}
          href={href}
          onClick={onCloseDrawer}
          className={`relative flex flex-col items-center gap-1 rounded-lg border px-1 py-2 text-[10px] font-medium transition ${
            mode === m || pathname === href
              ? "border-violet-500/50 bg-violet-600/15 text-violet-200"
              : "border-zinc-800 text-zinc-500 hover:border-zinc-700 hover:text-zinc-300"
          }`}
        >
          {icon}
          {label}
          {/* The tile is too small for a muted zero to read as anything but noise; the rail row and tab keep it. */}
          {m === "reports" && inboxCount !== null && inboxCount > 0 && <InboxCountBadge count={inboxCount} size="compact" className="absolute right-1 top-1" />}
        </Link>
      ))}
    </div>
  );
}
